import { useTranslation } from 'react-i18next';
import styles from './RewardCard.module.css';
//import { ReactComponent as Cup2SVG } from '@Assets/svg/trophy2.svg';
import { ReactComponent as CarSVG } from '@Assets/svg/car.svg';
import { ReactComponent as AmazonSVG } from '@Assets/svg/amazon.svg';
import { ReactComponent as GiftSVG } from '@Assets/svg/gift.svg';
import { useState } from 'react';

interface PremioCardProps {
	className?: string;
	contractsCounter: number;
	totContractsCompleted: number;
}

const rewards = [
	{ threshold: 3, value: '' },
	//{ threshold: 5, value: '€300' },
	{ threshold: 10, value: '€1000' }
];

const MAX_CONTRACTS = 10;

const RewardCard = ({ className, contractsCounter, totContractsCompleted }: PremioCardProps) => {
	const { t } = useTranslation();
	const [activeTooltip, setActiveTooltip] = useState<number | null>(null);

	const handleTooltipToggle = (threshold: number) => {
		setActiveTooltip((prev) => (prev === threshold ? null : threshold));
	};

	const carPositionPercentage = (Math.min(contractsCounter, MAX_CONTRACTS) / MAX_CONTRACTS) * 90;

	const isRewardUnlocked = (threshold: number) => {
		return contractsCounter >= threshold;
	};

	return (
		<div className={`${styles.premioCardContainer} ${className || ''}`}>
			<h2 className={styles.cardTitle}>{t('profile.rewards.title')}</h2>

			<div className={styles.roadContainer}>
				<div className={styles.road}>
					<div className={styles.roadDashedLine}></div>
					{rewards.map((reward) => (
						<div
							key={`prize-container-${reward.threshold}`}
							className={styles.prizeContainer}
							style={{ bottom: `${(reward.threshold / MAX_CONTRACTS) * 90}%` }}
						>
							<div
								key={`prize-value-${reward.threshold}`}
								className={styles.prizeValueOnRoad}
								onClick={() => handleTooltipToggle(reward.threshold)}
							>
								{reward.threshold === 3 ? <GiftSVG className={styles.svg} /> : <AmazonSVG className={styles.svg} />}
								{reward.value}
							</div>

							{/* Tooltip al click */}
							{activeTooltip === reward.threshold && (
								<div className={styles.tooltip}>
									{reward.threshold === 3 ? t('profile.rewards.tooltip3') : t('profile.rewards.tooltip10')}
								</div>
							)}
						</div>
					))}
				</div>

				{Array.from({ length: MAX_CONTRACTS }, (_, i) => {
					const number = i + 1;
					const rewardInfo = rewards.find((r) => r.threshold === number);

					return (
						<div
							key={`progress-${number}`}
							className={`${styles.progressMarker} ${
								rewardInfo && isRewardUnlocked(rewardInfo.threshold) ? styles.unlocked : ''
							}`}
							style={{ bottom: `${(number / MAX_CONTRACTS) * 90}%` }}
						>
							{/* Mostra la coppa solo se il numero è una soglia di premio */}
							{/*rewardInfo && <Cup2SVG className={styles.trophyIcon} />*/}
							<span>{number}</span>
						</div>
					);
				})}

				<div className={styles.carContainer} style={{ bottom: `${carPositionPercentage}%` }}>
					<CarSVG className={styles.carIcon} />
				</div>
			</div>

			<div className={styles.statsContainer}>
				<div className={styles.contractsCounter}>
					<span className={styles.countValue}>{contractsCounter}</span>
					<span className={styles.countLabel}>{t('profile.rewards.contractsCounter')}</span>
				</div>
				<div className={styles.contractsCounter}>
					<span className={styles.countValue}>{totContractsCompleted}</span>
					<span className={styles.countLabel}>{t('profile.rewards.totContractsCounter')}</span>
				</div>
				<div className={styles.nextReward}>
					{contractsCounter < 3 ? (
						<>
							<span className={styles.countValue}>+100</span>
							<span className={styles.countLabel}>{t('profile.rewards.nextLevel')}</span>
							<span className={styles.nextRewardRemaining}>
								{t('profile.rewards.remaining', { count: 3 - contractsCounter })}
							</span>
						</>
					) : /**
						: contractsCounter < 5 ? (
						<>
							<span className={styles.countValue}>100</span>
							<span className={styles.countLabel}>{t('profile.rewards.nextReward')}</span>
							<span className={styles.nextRewardRemaining}>
								{t('profile.rewards.remaining', { count: 5 - contractsCounter })}
							</span>
						</>
					) :
					 */
					contractsCounter < 10 ? (
						<>
							<span className={styles.countValue}>1000€</span>
							<span className={styles.countLabel}>{t('profile.rewards.amazon')}</span>
							<span className={styles.countLabel}>{t('profile.rewards.nextReward')}</span>
							<span className={styles.nextRewardRemaining}>
								{t('profile.rewards.remaining', { count: 10 - contractsCounter })}
							</span>
						</>
					) : (
						<span className={styles.allRewardsUnlocked}>{t('profile.rewards.allUnlocked')}</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default RewardCard;
